import useAuthService from "../session/AuthService";

const http = {
  HEADERS: () => {
    return {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: "JWT fefege...",
    };
  },
  AUTH_HEADERS: () => {
    return {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: useAuthService.getToken(),
    };
  },

  MULTIPART_HEADERS: () => {
    return {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
      Authorization: "",
    };
  },

  AUTH_MULTIPART_HEADERS: () => {
    return {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
      Authorization: useAuthService.getToken(),
    };
  },
};

export default http;
